module.exports = "<div class=\"star-rating\">\n\t<span ng-if=\"showValue === 'show'\" class=\"star-rating__value\">{{value || rating}}</span>\n\t<span ng-repeat=\"star in [1, 2, 3, 4, 5] track by $index\" class=\"star-rating__star\">\n\t\t<span class=\"icon icon-star-empty\" ng-if=\"rating <= star - 1\"></span>\n\t\t<span class=\"icon icon-star-half\" ng-if=\"rating > star - 1 && rating <= star -0.5\"></span>\n\t\t<span class=\"icon icon-star-full\" ng-if=\"rating > star - 0.5\"></span>\n\t</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/directive/star-rating/star-rating.html
// module id = 511
// module chunks = 0